import QuitButton from "../atoms/buttons/QuitButton.jsx";
import CancelQuitButton from "../atoms/buttons/CancelQuitButton.jsx";

export default function QuitConfirmation() {

    return (
        <div className="quit-confirmation-container">
            <div className="quit-confirmation-popup">
                <p>Are you sure you want to quit?</p>
                <div className="quit-confirmation-buttons">
                    <QuitButton/>
                    <CancelQuitButton/>
                </div>
            </div>
        </div>
    );
};
